module.exports = __webpack_public_path__ + "assets/deleteFile.06bba385c9ff05c331f804e7ed9a64f2.png";